export enum PlatformType {
    Senza = "Senza",
    Browser = "Browser",
}